import { render, staticRenderFns } from "./ArquitectosDeCabecera.vue?vue&type=template&id=9767e7a0&scoped=true"
import script from "./ArquitectosDeCabecera.vue?vue&type=script&lang=js"
export * from "./ArquitectosDeCabecera.vue?vue&type=script&lang=js"
import style0 from "./ArquitectosDeCabecera.vue?vue&type=style&index=0&id=9767e7a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9767e7a0",
  null
  
)

export default component.exports